import { render, staticRenderFns } from "./FormFinal.vue?vue&type=template&id=3ba6a189&scoped=true&"
import script from "./FormFinal.vue?vue&type=script&lang=js&"
export * from "./FormFinal.vue?vue&type=script&lang=js&"
import style1 from "./FormFinal.vue?vue&type=style&index=1&id=3ba6a189&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba6a189",
  null
  
)

export default component.exports
import QField from 'quasar/src/components/field/QField.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QField,QCard,QCardSection,QBtn});
